import { render, staticRenderFns } from "./custom-audience-dialog.vue?vue&type=template&id=4f1976a4&scoped=true&"
import script from "./custom-audience-dialog.vue?vue&type=script&lang=js&"
export * from "./custom-audience-dialog.vue?vue&type=script&lang=js&"
import style0 from "./custom-audience-dialog.vue?vue&type=style&index=0&id=4f1976a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1976a4",
  null
  
)

export default component.exports